import { defineComponent as m, inject as f, computed as o, ref as u, onMounted as a } from "vue";
import { useResizeObserver as d } from "./index562.js";
import { selectKey as W } from "./index676.js";
import { BORDER_HORIZONTAL_WIDTH as h } from "./index696.js";
import { useNamespace as v } from "./index559.js";
var C = m({
  name: "ElSelectDropdown",
  componentName: "ElSelectDropdown",
  setup() {
    const e = f(W), i = v("select"), r = o(() => e.props.popperClass), l = o(() => e.props.multiple), c = o(() => e.props.fitInputWidth), t = u("");
    function s() {
      var p;
      const n = (p = e.selectRef) == null ? void 0 : p.offsetWidth;
      n ? t.value = `${n - h}px` : t.value = "";
    }
    return a(() => {
      s(), d(e.selectRef, s);
    }), {
      ns: i,
      minWidth: t,
      popperClass: r,
      isMultiple: l,
      isFitInputWidth: c
    };
  }
});
export {
  C as default
};
